import React, { ChangeEvent, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    Tab,
    Tabs,
    TextField,
    Box,
    Typography,
    IconButton,
    CardMedia,
    Input,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";

const AddDriver = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [status, setStatus] = useState("default");
    const [tabIndex, setTabIndex] = useState(0);

    const handleStatusChange = (event: SelectChangeEvent) => {
        setStatus(event.target.value as string);
    };

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    const isAddUser = location.pathname === "/manage-users/add";

    // Helper for rendering each tab panel
    const TabPanel = ({
        children,
        value,
        index,
    }: {
        children: React.ReactNode;
        value: number;
        index: number;
    }) => {
        return (
            <div hidden={value !== index}>
                {value === index && <Box sx={{ mt: 3 }}>{children}</Box>}
            </div>
        );
    };
    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    return (
        <>
            <div className="main_title">
                <h1>Add Driver</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-drivers")}>
                        Manage Drivers
                    </button>{" "}
                    - {isAddUser ? "Add " : "Edit "} Driver
                </p>
            </div>

            <Box className="custom_tabs1">
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    aria-label="Driver Details Tabs"
                    textColor="primary"
                    indicatorColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    className="custom_tabs_links"
                >
                    <Tab label="General Details" />
                    <Tab label="Documents" />
                    <Tab label="Vehicle Details" />
                    <Tab label="Bank Details" />
                </Tabs>
            </Box>
            <div className="cards">
                {/* TAB 1: General Details */}

                <TabPanel value={tabIndex} index={0}>
                    <div className="form">
                        <div className="gap_p">
                            {/* Profile Image Upload */}
                            <div className="control_group w_100">
                                <div className="gap_p">

                                    <div className="control_group w_33">
                                        <label>Upload Image</label>
                                        {image ? (
                                            <div className="upload_image v2 no_radius">
                                                <div className="upload_image_holder">
                                                    <figure>
                                                        <CardMedia component="img" image={image} alt="Uploaded" />
                                                    </figure>
                                                    <IconButton
                                                        aria-label="Remove"
                                                        onClick={() => {
                                                            setImage("");
                                                            setFileName("");
                                                        }}
                                                        size="small"
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        ) : (
                                            <label className="upload_image v2 no_radius" htmlFor="fileUpload">
                                                <Input
                                                    id="fileUpload"
                                                    sx={{ display: "none" }}
                                                    type="file"
                                                    inputProps={{ accept: "image/png,image/jpeg" }}
                                                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                        const files = event.target.files;
                                                        if (files && files[0].type.includes("image")) {
                                                            setFileName(files[0].name);
                                                            setImage(URL.createObjectURL(files[0]));
                                                        }
                                                    }}
                                                />
                                                <span className="upload_image_holder">
                                                    <figure className="add_img">
                                                        <img
                                                            src="/static/images/placeholder.png"
                                                            alt="placeholder"
                                                        />
                                                    </figure>
                                                </span>
                                            </label>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Name */}
                            <div className="control_group w_33">
                                <label>
                                    Name
                                </label>
                                <TextField placeholder="Enter Name" fullWidth />
                            </div>

                            {/* Email */}
                            <div className="control_group w_33">
                                <label>
                                    Email
                                </label>
                                <TextField type="email" placeholder="Enter Email" fullWidth />
                            </div>

                            {/* Phone Number */}
                            <div className="control_group w_33">
                                <label>
                                    Phone Number
                                </label>
                                <PhoneInput
                                    country={"in"}
                                    placeholder="Enter Phone Number"
                                    inputStyle={{ width: "100%" }}
                                />
                            </div>

                            {/* Gender */}
                            <div className="control_group w_33">
                                <label>
                                    Gender
                                </label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>
                                        Select Gender
                                    </MenuItem>
                                    <MenuItem value="male">Male</MenuItem>
                                    <MenuItem value="female">Female</MenuItem>
                                    <MenuItem value="other">Other</MenuItem>
                                </Select>
                            </div>
                            <div className="control_group w_33">
                                <label>
                                    Add Geofence
                                </label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>
                                        Select 
                                    </MenuItem>
                                    <MenuItem value="mumbai">Geofence1</MenuItem>
                                    <MenuItem value="bangalore">Geofence2</MenuItem>
                                </Select>
                            </div>
                            {/* Country */}
                            <div className="control_group w_33">
                                <label>
                                    Country
                                </label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>
                                        Select Country
                                    </MenuItem>
                                    <MenuItem value="india">India</MenuItem>
                                    <MenuItem value="usa">USA</MenuItem>
                                    <MenuItem value="uk">UK</MenuItem>
                                </Select>
                            </div>

                            {/* State */}
                            <div className="control_group w_33">
                                <label>
                                    State
                                </label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>
                                        Select State
                                    </MenuItem>
                                    <MenuItem value="maharashtra">Maharashtra</MenuItem>
                                    <MenuItem value="karnataka">Karnataka</MenuItem>
                                </Select>
                            </div>

                            {/* City */}
                            <div className="control_group w_33">
                                <label>
                                    City
                                </label>
                                <Select defaultValue="def" fullWidth>
                                    <MenuItem value="def" disabled>
                                        Select City
                                    </MenuItem>
                                    <MenuItem value="mumbai">Mumbai</MenuItem>
                                    <MenuItem value="bangalore">Bangalore</MenuItem>
                                </Select>
                            </div>

                            {/* Pin Code */}
                            <div className="control_group w_33">
                                <label>
                                    Pin Code
                                </label>
                                <TextField placeholder="Enter Pin" fullWidth />
                            </div>

                            {/* Address Line 1 */}
                            <div className="control_group w_50">
                                <label>
                                    Address Line 1
                                </label>
                                <TextField placeholder="Enter Address Line 1" fullWidth />
                            </div>

                            {/* Address Line 2 */}
                            <div className="control_group w_50">
                                <label>
                                    Address Line 2
                                </label>
                                <TextField placeholder="Enter Address Line 2" fullWidth />
                            </div>
                        </div>

                        <div className="form_btn" >
                            <Button
                                variant="contained"
                                color="success"
                                className="btn btn_primary"
                                onClick={() => setTabIndex(1)}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                </TabPanel>


                {/* TAB 2: Documents */}
                <TabPanel value={tabIndex} index={1}>
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_50">
                                <label>
                                    Document Name
                                </label>
                                <TextField placeholder="Enter Document Name" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label>
                                    Expiry date
                                </label>
                                <TextField placeholder="Enter Expiry date" fullWidth />
                            </div>
                            <div className="control_group w_50">
                                <label>Upload Front Image</label>
                                {image ? (
                                    <div className="upload_image v2 no_radius">
                                        <div className="upload_image_holder">
                                            <figure>
                                                <CardMedia component="img" image={image} alt="Uploaded" />
                                            </figure>
                                            <IconButton
                                                aria-label="Remove"
                                                onClick={() => {
                                                    setImage("");
                                                    setFileName("");
                                                }}
                                                size="small"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                ) : (
                                    <label className="upload_image v2 no_radius" htmlFor="fileUpload">
                                        <Input
                                            id="fileUpload"
                                            sx={{ display: "none" }}
                                            type="file"
                                            inputProps={{ accept: "image/png,image/jpeg" }}
                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                const files = event.target.files;
                                                if (files && files[0].type.includes("image")) {
                                                    setFileName(files[0].name);
                                                    setImage(URL.createObjectURL(files[0]));
                                                }
                                            }}
                                        />
                                        <span className="upload_image_holder">
                                            <figure className="add_img">
                                                <img
                                                    src="/static/images/placeholder.png"
                                                    alt="placeholder"
                                                />
                                            </figure>
                                        </span>
                                    </label>
                                )}
                            </div>
                            <div className="control_group w_50">
                                <label>Upload Back Image</label>
                                {image ? (
                                    <div className="upload_image v2 no_radius">
                                        <div className="upload_image_holder">
                                            <figure>
                                                <CardMedia component="img" image={image} alt="Uploaded" />
                                            </figure>
                                            <IconButton
                                                aria-label="Remove"
                                                onClick={() => {
                                                    setImage("");
                                                    setFileName("");
                                                }}
                                                size="small"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                ) : (
                                    <label className="upload_image v2 no_radius" htmlFor="fileUpload">
                                        <Input
                                            id="fileUpload"
                                            sx={{ display: "none" }}
                                            type="file"
                                            inputProps={{ accept: "image/png,image/jpeg" }}
                                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                                const files = event.target.files;
                                                if (files && files[0].type.includes("image")) {
                                                    setFileName(files[0].name);
                                                    setImage(URL.createObjectURL(files[0]));
                                                }
                                            }}
                                        />
                                        <span className="upload_image_holder">
                                            <figure className="add_img">
                                                <img
                                                    src="/static/images/placeholder.png"
                                                    alt="placeholder"
                                                />
                                            </figure>
                                        </span>
                                    </label>
                                )}
                            </div>

                        </div>
                        <div className="form_btn" >
                            <Button
                                variant="contained"
                                color="success"
                                className="btn btn_primary"
                                onClick={() => setTabIndex(2)}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                </TabPanel>

                {/* TAB 3: Vehicle Details */}
                <TabPanel value={tabIndex} index={2}>
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_33">
                                <label>Vehicle Number</label>
                                <TextField placeholder="Enter Vehicle Number" fullWidth />
                            </div>
                            <div className="control_group w_33">
                                <label>Vehicle Model</label>
                                <TextField placeholder="Enter Model" fullWidth />
                            </div>
                            <div className="control_group w_33">
                                <label>Vehicle Color</label>
                                <TextField placeholder="Enter Color" fullWidth />
                            </div>
                            <div className="control_group w_33">
                                <label>Registration Expiry</label>
                                <TextField type="date" fullWidth />
                            </div>
                        </div>
                        <div className="form_btn" >
                            <Button
                                variant="contained"
                                color="success"
                                className="btn btn_primary"
                                onClick={() => setTabIndex(3)}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                </TabPanel>

                {/* TAB 4: Bank Details */}
                <TabPanel value={tabIndex} index={3}>
                    <div className="form">
                        <div className="gap_p">
                            <div className="control_group w_33">
                                <label>Bank Name</label>
                                <TextField placeholder="Enter Account Name" fullWidth />
                            </div>
                            <div className="control_group w_33">
                                <label>Account Holder Name</label>
                                <TextField placeholder="Enter Account Name" fullWidth />
                            </div>
                            <div className="control_group w_33">
                                <label>Account Number</label>
                                <TextField placeholder="Enter Account Number" fullWidth />
                            </div>
                            <div className="control_group w_33">
                                <label>IFSC Code</label>
                                <TextField placeholder="Enter IFSC Code" fullWidth />
                            </div>
                        </div>
                        <div className="form_btn" >
                            <Button
                                variant="contained"
                                color="success"
                                className="btn btn_primary"
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                </TabPanel>


            </div>
        </>
    );
};

export default AddDriver;
